module.exports = __webpack_public_path__ + "static/img/modelDetails3.5de44af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/模型库/modelDetails3.png
// module id = ydH3
// module chunks = 1